import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import ListCard, {
  ListCardNotDeduction,
  ListCardNotSetDeduction,
} from '../../../components/ListCard';
import Typography from '../../../components/common/Typography';
import { formatNumber, getTotal, nameRelation } from '../../../common/Util';
import {
  getEducationInfo,
  resetEducationState,
  setSelectedEducationDetail,
} from './educationSlice';
import { relationOptions } from '../../../common/data';

/*
	이름 : v.htm038
	관계 : familyCode[v.htm002]
	주민등록번호 : v.htm001
	교육비코드 : v.htm015
	교복비 국세청 : v.htm072
	현장학습비 국세청 : v.htm110
	교육비(일반) 국세청 : v.htm023
	교복비 국세청외 : v.htm073
	현장학습비 국세청외 : v.htm111
	교육비(일반) 국세청외 : v.htm024
 */

const EducationItemSection = ({ onOpen }) => {
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const { dataList, isRender, reload } = useSelector(state => state.education);
  const { t: tDependents } = useTranslation('dependents');
  const relationList = relationOptions(tDependents);

  //초기 데이터 호출
  useEffect(() => {
    dispatch(getEducationInfo());
  }, []);

  //저장, 삭제시 재호출
  useEffect(() => {
    if (reload != -1) {
      dispatch(getEducationInfo());
    }
  }, [reload]);

  //언마운트시 초기화
  useEffect(() => {
    return () => {
      dispatch(resetEducationState());
    };
  }, [dispatch]);

  const handleClick = data => {
    if (data?.htm001) {
      dispatch(setSelectedEducationDetail({ htm001: data?.htm001 }));
      onOpen();
    }
  };

  const content = (data, index, title) => {
    if (data.deType == '1') {
      return (
        <ListCard
          key={index}
          onClick={() => handleClick(data)}
          content={<ListCardContent data={data} title={title} />}
          isFirst={index === 0}
          title="교육비"
        />
      );
    }
    if (data.deType == '2') {
      return <ListCardNotDeduction title={title} key={index} />;
    }

    return <ListCardNotSetDeduction title={title} key={index} />;
  };

  return (
    <div>
      {dataList?.map((data, index) => {
        //이름 (관계)
        let title = nameRelation(tDependents, data);
        return content(data, index, title);
      })}
    </div>
  );
};

export default EducationItemSection;

const ListCardContent = ({ data, title }) => {
  const { t } = useTranslation('deductions/education');

  const documentItem = () => {
    if (
      Number(data?.htm024 || 0) > 0 ||
      Number(data?.htm073 || 0) > 0 ||
      Number(data?.htm111 || 0) > 0
    ) {
      return t('card.item4');
    } else {
      return t('card.item3');
    }
  };

  return (
    <div>
      <Typography variant="body2Bold">{title}</Typography>
      <Typography variant="captionMedium">
        {/* 국세청 일반 / 그외*/}
        {t('card.itemTitle1')} {t('card.item1')}: {formatNumber(data?.htm023 || 0)}
        {t('card.price')} / {t('card.item2')} :{' '}
        {formatNumber(getTotal([data], ['htm072', 'htm110']))}
        {t('card.price')}
      </Typography>
      {/* 국세청외 일반 / 그외 */}
      <Typography variant="captionMedium" color="Primary-500">
        {t('card.itemTitle2')} {t('card.item1')}: {formatNumber(data?.htm024 || 0)}
        {t('card.price')} / {t('card.item2')} :{' '}
        {formatNumber(getTotal([data], ['htm073', 'htm111']))}
        {t('card.price')}
      </Typography>
      <Typography variant="captionMedium">
        {t('card.itemTitle3')} : {documentItem()}
      </Typography>
    </div>
  );
};
